import { getQueryString } from 'helpers/queryParams';
import {} from 'interfaces/jsonapi';
import { BASE_API_URL } from 'services/api';
const getPartnerships = (partnershipId) => (partnershipId ? `/partnerships/${partnershipId}` : ``);
const getPaymentId = (paymentId) => (paymentId ? `/${paymentId}` : ``);
const getParams = (params) => (params ? `?${getQueryString(params)}` : ``);
export const paymentsEndpoint = `${BASE_API_URL}/payments/`;
export const getPaymentsEndpoint = ({ partnershipId, paymentId, params }) => `${BASE_API_URL}${getPartnerships(partnershipId)}/payments${getPaymentId(paymentId)}/${getParams(params)}`;
